





















































import { Component, Vue, Prop, Provide, Watch } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import Paper from './components/Paper.vue'
import DownLoadBtn from './components/DownLoadBtn.vue'
import DownLoadModal from './components/DownLoadModal.vue'
import SyncModal from './components/SyncModal.vue'
import OrderList from './components/OrderList.vue'
import { throttle, debounce } from 'throttle-debounce'
import { sa } from '@/utils/sa'

@Component({
  components: { MainTemplate, Paper, DownLoadBtn, DownLoadModal, OrderList, SyncModal },
  beforeRouteEnter(to, from, next) {
    next((vm: any) => {
      // 通过 `vm` 访问组件实例
      if (from && from.name) {
        vm.from = from
      }
    })
  }
})
export default class Preview extends Vue {
  public titleFixed = false
  public visible = false
  public syncVisible = false
  public disbaled = false
  public questions = []
  public classification = []
  public from = '/search'
  public syncBtnStatus = false
  public tikuUrl = ''

  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get userInfo() {
    return this.$store.state.user_info
  }

  public mounted() {
    this.titleFixed = false
    window.addEventListener('scroll', throttle(20, this.handleScroll), true)
    // this.questions = this.cartInfo.question_ids
    // let temp: any = []
    // for (let n in this.cartInfo.classification) {
    //   temp = [
    //     ...temp,
    //     {
    //       key: n,
    //       name: this.cartInfo.classification[n].type,
    //       val: this.cartInfo.classification[n].sequence
    //     }
    //   ]
    // }
    // this.classification = temp
  }
  /**
   * handleScroll
   */
  public handleScroll() {
    let offsetTop = (this.$refs.pride_tab_fixed as any).getBoundingClientRect().top
    this.titleFixed = offsetTop < 0
  }
  public showModal() {
    if (!this.cartInfo) return
    if (!this.cartInfo.title) {
      this.$message.warning('还没有填写试卷名称哦')
      return
    }
    if (this.cartInfo && this.cartInfo.question_ids && this.cartInfo.question_ids.length) {
      this.visible = true
    }
    setTimeout(() => {
      sa.track('ContentRepository_question_Download', {
        action: '弹窗',
        modules: this.$route.path === '/auto/preview' ? '智能出题' : '手工组卷'
      })
    }, 50)
  }
  public showAsyncModal() {
    if (!this.cartInfo) return
    if (!this.cartInfo.title) {
      this.$message.warning('还没有填写试卷名称哦')
      return
    }
    if (this.cartInfo && this.cartInfo.question_ids && this.cartInfo.question_ids.length) {
      this.syncVisible = true
    }
  }
  public onCancel() {
    this.visible = false
    this.syncVisible = false
  }
  public onFinish(val) {
    console.log(val)
    this.syncBtnStatus = val.finish
    this.tikuUrl = val.url || ''
  }
  public goTiku() {
    if (!this.tikuUrl) return
    window.open(this.tikuUrl)
  }
}
